const Checkbox = ({ children, checked, set_checked }) => {
  return (
    <div className={'checkbox' + (checked ? ' checked' : '')} onClick={ set_checked }>{ children }</div>
  );
};

export default Checkbox;